{
  "clear": "נקה",
  "invalid": "(לא חוקי)",
  "loading": "טוען...",
  "noResults": "אין תוצאות"
}
